import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  id: "filter-header-container",
  class: "filter-header"
}
const _hoisted_2 = {
  key: 0,
  class: "selected-options"
}
const _hoisted_3 = {
  key: 0,
  class: "selected-options--thin"
}

import ChipBase from '@lmt-rpb/Atoms/ChipBase/ChipBase.vue';
import type { LabelValue } from '@components/common/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterHeaderChipList',
  props: {
    elements: {},
    hideValue: { type: Boolean, default: false }
  },
  emits: ['removeSelection'],
  setup(__props: any, { emit: __emit }) {


const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.elements.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, ({ label, value }) => {
            return (_openBlock(), _createBlock(ChipBase, {
              key: value,
              as: 'div',
              "with-delete": true,
              thin: true,
              onClick: _withModifiers(($event: any) => (emits('removeSelection', value)), ["stop"]),
              onDeleteClick: _withModifiers(($event: any) => (emits('removeSelection', value)), ["stop"])
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(label) + " ", 1 /* TEXT */),
                (value && !_ctx.hideValue)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (" + _toDisplayString(value) + ") ", 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "onDeleteClick"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})